/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { PopoverProps } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Drawer } from 'components/atoms/drawer';
import { Popover } from 'components/atoms/popover';
import { useIsResponsive } from 'hooks/use-media-query';

export const LaptopPopover = styled(Popover)`
  .ant-popover-inner {
    box-shadow: var(--shadow-08);
    border-radius: var(--border-radius-small);
    overflow: hidden;
  }

  .ant-popover-inner-content {
    padding: 0;
    overflow: hidden;
  }
`;

const CpDrawer = styled(Drawer)<{ height?: string }>`
  .ant-drawer-content {
    border-radius: var(--border-radius-small) var(--border-radius-small) 0 0;
  }
  .ant-drawer-content-wrapper {
    min-height: max-content !important;
    max-height: 80svh;
    height: ${(props) => props?.height ?? '60svh'} !important;
  }
  .ant-drawer-body {
    overflow-y: hidden;
  }
  .ant-drawer-body,
  .ant-menu {
    /* hide scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar-thumb {
      display: none;
    }
  }
  .ant-drawer-body {
    padding: 0;
    .ant-menu {
      max-height: 100%;
      box-shadow: none;
      width: 100%;
      @media (max-width: 480px) {
        .ant-menu-item {
          height: 48px;
        }
      }
    }
  }
`;

export const CpPopover: React.FC<
  PopoverProps & {
    height?: string;
    closeOnSelect?: boolean;
    onClose?: () => void;
  }
> = ({ height, closeOnSelect, ...props }) => {
  const isResponsive = useIsResponsive();
  // eslint-disable-next-line react/destructuring-assignment
  const visible = useMemo(() => props?.visible ?? false, [props?.visible]);
  const [isOpened, setIsOpened] = useState<boolean>(
    visible !== null && visible !== undefined ? !!visible : false,
  );

  useEffect(() => {
    if (visible !== null && visible !== undefined) {
      setIsOpened(!!visible);
    }
  }, [visible]);

  const onClose = useCallback(() => {
    setIsOpened(false);
    // hacky way to wait for drawer to close
    setTimeout(() => {
      props?.onClose?.();
      props?.onVisibleChange?.(false);
    }, 1000);
  }, [props]);

  const children = useMemo(() => props?.content ?? props?.overlay, [props]);
  const childrenWithWrapper = useMemo(
    () =>
      closeOnSelect ? <span onClick={onClose}>{children}</span> : children,
    [children, closeOnSelect, onClose],
  );

  if (isResponsive) {
    return (
      <>
        <CpDrawer
          height={height}
          placement="bottom"
          // {...props}
          visible={isOpened}
          onClose={onClose}
          closeIcon={null}
          className={props?.className}
          destroyOnClose={!!props?.destroyTooltipOnHide}
          getContainer={() =>
            document.getElementById('cp-modal-root') as HTMLElement
          }
          mask
          maskClosable
        >
          {childrenWithWrapper}
        </CpDrawer>
        <span onClick={() => setIsOpened((p) => !p)}>{props?.children}</span>
      </>
    );
  }

  return (
    <LaptopPopover
      {...props}
      content={childrenWithWrapper}
      visible={isOpened}
      onVisibleChange={(change: boolean) => {
        props?.onVisibleChange?.(change);
        setIsOpened(change);
      }}
    />
  );
};
